import './Reg.css';
import React, { useEffect, useRef, useState } from 'react';
import useInfo from '../../hooks/use-info';
import useDb from '../../hooks/use-db';
import Ct from '../dropdowns/Ct';
import Sgg from '../dropdowns/Sgg';
import { useViewUpdate } from '../../context/view';

const Reg = () => {
  // settings ----------------------------------------------------------------------
  const { setLdcuid, left, scrn, setRight, setLeft, ldcuid, exp, setExp, bar } =
    useInfo();

  const needsRegionGlow =
    (bar === 1 && !ldcuid) ||
    (bar === 3 && (!ldcuid || ldcuid[0]?.slice(2) === '000'));
  const { getReg } = useDb();
  const divEl = useRef();
  const ctrf = useRef([]);
  const sggrf = useRef([]);
  const regfet = useRef(null);
  const [tmpldc, setTmpldc] = useState(null);
  const setView = useViewUpdate();

  // useEffect ----------------------------------------------------------------------
  useEffect(() => {
    const handler = (event) => {
      if (!divEl.current) return;
      if (!divEl.current.contains(event.target)) {
        if (!ldcuid) {
          setExp(0);
        } else {
          setExp(2);
        }
      }
    };
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, [ldcuid, setExp]);

  useEffect(() => {
    if (ldcuid) setExp(2);
  }, [ldcuid, setExp]);

  // 시/군/구 선택 즉시 확정, 시/도 선택 시 지도 미리보기
  useEffect(() => {
    if (!tmpldc) return;
    const zm = scrn < 1015 ? tmpldc[8] : tmpldc[7];
    if (tmpldc[4]?.slice(2) !== '000') {
      // 시/군/구 → 즉시 확정
      setLdcuid(tmpldc);
      setView({ longitude: tmpldc[5], latitude: tmpldc[6], zoom: zm });
      setExp(2);
    } else {
      // 시/도 → 지도 미리보기만
      setView({ longitude: tmpldc[5], latitude: tmpldc[6], zoom: zm });
    }
  }, [tmpldc, setLdcuid, setView, setExp, scrn]);

  // handles ----------------------------------------------------------------------
  const handleRgBtn = async () => {
    if (scrn < 1015) {
      setRight(false);
      setLeft(false);
    }
    if (!regfet.current) {
      const dataF = await getReg();
      regfet.current = dataF;
    }
    if (exp === 1) {
      if (!ldcuid) setExp(0);
      else setExp(2);
      return;
    }
    const ctlist = regfet.current.filter((item) => item.ldc.slice(2) === '000');
    const sgglist = regfet.current.filter((item) => item.ldc.slice(2) !== '000');
    ctrf.current = ctlist;
    sggrf.current = sgglist;
    setTmpldc(null);
    // ldcuid는 건드리지 않음 — 기존 선택 유지
    setExp(1);
  };

  const handleCityConfirm = () => {
    if (tmpldc && tmpldc[4]?.slice(2) === '000') {
      setLdcuid(tmpldc);
      setExp(2);
    }
  };

  const handleClear = (e) => {
    e.stopPropagation();
    setLdcuid(null);
    setTmpldc(null);
    setExp(0);
  };

  // render ----------------------------------------------------------------------
  var rendered;
  switch (exp) {
    case 1:
      rendered = (
        <div
          ref={divEl}
          className={`regionExp ${left ? '' : 'rmv_regionExp'} ${
            tmpldc ? 'exp1' : ''
          }`}
        >
          <div
            className={`region ${left ? '' : 'rmv_region'} ${needsRegionGlow ? 'need-action' : ''}`}
            style={{
              border: '0px',
              top: `${scrn < 1015 ? '11px' : '15px'}`,
              left: `${scrn < 1015 && '61px'}`,
            }}
            onClick={handleRgBtn}
          >
            지역선택
          </div>
          <div className="city">
            <div className="reg_ttl">{tmpldc ? tmpldc[1] : '시/도'}</div>
            <Ct
              ctrf={ctrf.current}
              tmpldc={tmpldc}
              setTmpldc={setTmpldc}
              ldcuid={ldcuid}
            />
            {tmpldc && tmpldc[4]?.slice(2) === '000' && (
              <div className="reg_city_confirm" onClick={handleCityConfirm}>
                {tmpldc[1]}(으)로 선택
              </div>
            )}
          </div>
          {tmpldc && (
            <div className="county">
              <div className="reg_ttl">
                {tmpldc[4]?.slice(2) !== '000' ? tmpldc[2] : '시/군/구'}
              </div>
              <Sgg
                sggrf={sggrf.current}
                tmpldc={tmpldc}
                setTmpldc={setTmpldc}
                ldcuid={ldcuid}
              />
            </div>
          )}
        </div>
      );
      break;
    case 2:
      rendered = (
        <div
          className={`regionExp ${left ? '' : 'rmv_regionExp'} ${
            ldcuid && ldcuid[0].slice(2) !== '000' && scrn > 1015 ? 'exp1' : ''
          } exp2`}
        >
          <div
            className={`region ${left ? '' : 'rmv_region'} ${needsRegionGlow ? 'need-action' : ''}`}
            style={{
              border: '0px',
              top: `${scrn < 1015 ? '11px' : '15px'}`,
              left: `${scrn < 1015 && '61px'}`,
            }}
            onClick={handleRgBtn}
          >
            지역선택
          </div>
          <div className="city">
            <div className="reg_ttl">{ldcuid ? ldcuid[1] : '시/도'}</div>
          </div>
          {ldcuid && ldcuid[0].slice(2) !== '000' && (
            <div className="county scrnSmll">
              <div className="reg_ttl">{ldcuid[2]}</div>
            </div>
          )}
          <div className="reg_clear" onClick={handleClear}>
            ✕
          </div>
        </div>
      );
      break;
    default:
      rendered = (
        <div
          className={`region ${left ? '' : 'rmv_region'} ${needsRegionGlow ? 'need-action' : ''}`}
          onClick={handleRgBtn}
        >
          지역선택
        </div>
      );
      break;
  }

  // return ----------------------------------------------------------------------
  return rendered;
};

export default Reg;
